module.exports = __webpack_public_path__ + "static/media/af.26d0dcc7.svg";